import { z } from "zod";

import { userSchema } from "../user/userSchema";

export const triviaLeaderboardSchema = z.object({
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  has_friends: z.boolean(),
  scores: z.array(
    z.object({
      score: z.number(),
      user: userSchema,
    }),
  ),
});

export type TriviaLeaderboard = z.infer<typeof triviaLeaderboardSchema>;
